// AB#1901 — These integer-valued enums are kept for FE-local state typing
// (form pickers, Redux slices, switch statements on already-parsed values).
//
// DO NOT compare them directly against fields off the wire — the BE serializes
// every enum as a STRING via the global JsonStringEnumConverter (see
// `Devanza.API/Program.cs:76-89`, cemented by PR #1131 / AB#1840 on 2026-06-01).
//
// At the response→state boundary, normalize using the helpers in
// `src/lib/enumParsers.ts` (e.g. `parseGender`, `parseServiceType`,
// `parseAppointmentStatus`, `parsePaymentStatus`). String-union wire types
// live in `src/lib/wireEnums.ts`. Architecture brief:
// `devanza-claude/docs/features/AB1894/arch-brief.md`.

export enum ProfileType {
    Customer = 1,
    SalonOwner = 2,
    SalonStaff = 3,
    SuperAdmin = 4
}

export enum BusinessType {
    Men = 1,
    Women = 2,
    Both = 3
}

export enum ServiceType {
    MenOnly = 1,
    WomenOnly = 2,
    Everyone = 3
}

export enum Gender {
    Male = 1,
    Female = 2,
    Other = 3
}

export enum AppointmentStatus {
    Pending = 1,
    Confirmed = 2,
    Completed = 3,
    Cancelled = 4,
    NoShow = 5,
    // P0-3 (AB#2043) — post-C4 lifecycle states already emitted by the BE
    // (Devanza.Core/Enums/AppointmentEnums.cs) and handled by the wire
    // parsers/`AppointmentCard` numeric cases. Declared here so status-change
    // callers (`useAppointments.updateStatus`) can reference them type-safely.
    Arrived = 6,
    Started = 7
}

export enum PaymentStatus {
    Paid = 1,
    Unpaid = 2,
    Upcoming = 3,
    Draft = 4,
    Late = 5
}
